import { Pipe, PipeTransform } from '@angular/core';
import { DocumentElementResponse } from 'src/openapi-client';

@Pipe({
  name: 'elementContentString',
  standalone: true,
})
export class ElementContentStringPipe implements PipeTransform {
  public transform(element: DocumentElementResponse | undefined): string {
    if (!element) {
      return '';
    }

    if (!('content' in element.renderable)) {
      throw new Error(`Provided element has no content.`);
    }

    return element.renderable.content;
  }
}
